import { actions, services } from '@ehi/global-marketing-interface';

export const getCarClassDetails = (carClassCode) => (dispatch) =>
  dispatch(
    actions.request({
      service: services.gma.reservations.carClassDetails,
      data: { params: { carClassCode } },
    })
  );
